<div class="d-flex flex-column align-items-center overflow-hidden"
     *adaptIfAuthorised="EditObjectives">
    <button class="btn btn-primary"
            [adaptBlockingClick]="gotoObjectivesPage">{{buttonText}}
    </button>
</div>
